'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PricingCards from '@/app/book-a-session/components/PricingCards';
import BookingForm from '@/app/book-a-session/components/BookingForm';
import HowItWorks from '@/app/book-a-session/components/HowItWorks';

export default function BookASessionPage() {
  const [selectedPlan, setSelectedPlan] = useState<string>('audio-45');

  return (
    <>
      <Header />
      <main className="bg-background min-h-screen">
        {/* Page Header */}
        <section className="navy-gradient py-16 lg:py-20">
          <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 text-center">
            <p className="section-label text-accent mb-3">Sessions 1-on-1</p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4">
              Parlez à Marc
            </h1>
            <p className="text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
              Sessions individuelles en ligne. Audio ou vidéo. Marc répond naturellement, comme dans la vraie vie.
            </p>
          </div>
        </section>

        <PricingCards selected={selectedPlan} onSelect={setSelectedPlan} />
        <BookingForm initialSessionType={selectedPlan} />
        <HowItWorks />
      </main>
      <Footer />
    </>
  );
}